/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Ourcompany_Pointthree2Inputs */

const ja_company_ourcompany_pointthree2 = /** @type {(inputs: Company_Ourcompany_Pointthree2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私たちは、ゲームの魅力、ファッションとの融合、そしてeスポーツの競技シーンの魅力をより多くの人々に伝えることに力を注いでいます。`)
};

const en_company_ourcompany_pointthree2 = /** @type {(inputs: Company_Ourcompany_Pointthree2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sharing game culture is the mission we pursue.`)
};

/**
* | output |
* | --- |
* | "Sharing game culture is the mission we pursue." |
*
* @param {Company_Ourcompany_Pointthree2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_ourcompany_pointthree2 = /** @type {((inputs?: Company_Ourcompany_Pointthree2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Ourcompany_Pointthree2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_ourcompany_pointthree2(inputs)
	return en_company_ourcompany_pointthree2(inputs)
});
export { company_ourcompany_pointthree2 as "company_ourCompany_pointThree" }